module.exports = __webpack_public_path__ + "img/stockantsmanager.3114cee0.jpeg";